import React from "react";
import {Grid} from "@mui/system";
import style from "../../assets/css/home.module.scss";
import {Button} from "@mui/material";
import {Link} from "react-router-dom";

function InsureJewelry() {
  return (
    <>
      <section className={style.insureSection}>
        <Grid
          container
          spacing={2}
          className="customeContainer"
          justifyContent="center"
          alignItems="center"
        >
          <Grid size={{xs: 12, lg: 12, xl: 12}}>
            <div className={style.InsureMain}>
              <h2> Insure Your Jewelry Today </h2>
              <p>
                {" "}
                Jewelry insurance through Associated International Brokers, Inc
                Jewelry Insurance is easy to purchase <br />
                and affordable. Apply and buy online in minutes.{" "}
              </p>
              <Link to="/login">
                <Button verient="contained"> Get Insured Now </Button>
              </Link>
            </div>
          </Grid>
        </Grid>
      </section>
    </>
  );
}

export default InsureJewelry;
